<template>
  <div :class="getScrollOverlayClass">
    <vue-scroll class="scroll-list" :ops="ops">
      <div
        v-for="(item, index) in listItems"
        :key="index"
        :class="getItemClass(item)"
        @click="itemClick(item)"
      >
        <span>{{ item.title }}</span>
        <i v-if="isItemFetched(item)" class="icon icon-check"></i>
      </div>
    </vue-scroll>
  </div>
</template>

<script>
import ItemsScrollListMixin from "../../Common/ItemsScrollListMixin";

export default {
  name: "ArsenalItems",

  mixins: [ItemsScrollListMixin],

  props: {
    activeItemData: Object,
  },

  methods: {
    itemClick(item) {
      this.$emit("changeActiveItem", item);
    },

    getItemClass(item) {
      return [
        "scroll-item",
        this.isItemFetched(item) ? "item-fetched" : "",
        item.reward.item.id === this.activeItemData.reward.item.id ? "item-active" : "",
      ];
    },

    isItemFetched(item) {
      return item.fetched;
    },
  },
};
</script>
